import { Component, createElement } from 'react'
import PropTypes from 'prop-types'
import isNil from 'lodash/isNil'
import moment from 'moment'
import { connectGetters } from 'react-redux-getters'
import { getUtcOffset } from 'selectors/me'

export const momentOffset = (offset, ...args) => {
  const dateMoment = moment(...args)
  return isNil(offset) ? dateMoment : dateMoment.utcOffset(offset)
}

const mapGettersToProps = state => ({
  utcOffsetGetter: getUtcOffset(state)
})

export const withTimezone = wrappedComponent => @connectGetters(mapGettersToProps)
  class WithTimezone extends Component {
    static propTypes = {
      utcOffsetGetter: PropTypes.object.isRequired,
    }

    momentTz = (...args) => {
      const { utcOffsetGetter } = this.props
      return momentOffset(utcOffsetGetter.data, ...args)
    }

    render() {
      const { utcOffsetGetter, ...rest } = this.props
      return createElement(wrappedComponent, {
        ...rest,
        utcOffset: utcOffsetGetter.data,
        momentTz: this.momentTz
      })
    }
}

export const setTime = (dateDonor, timeDonor, utcOffset) => {
  const dateDonorMoment = momentOffset(utcOffset, dateDonor)
  const dateWithTimeMoment = momentOffset(utcOffset, timeDonor)
  dateDonorMoment.hour(dateWithTimeMoment.hour())
  dateDonorMoment.minute(dateWithTimeMoment.minute())
  return dateDonorMoment.toDate()
}
